import { Component, Input, OnInit } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
import * as FileSaver from 'file-saver';

import { NotificationService } from '../../services/notification.service';
import { FileDataService, IFileInfo } from '../../services/file-data.service';

@Component({
  selector: 'renci-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.css']
})
export class FileDownloadComponent implements OnInit {

  @Input()
  public file: IFileInfo;

  public canDisplayLink = false;

  constructor(
    private notificationService: NotificationService,
    private dataService: FileDataService) { }

  ngOnInit() {
    if (this.file.fileId) {
      this.canDisplayLink = true;
    }
  }

  public click(event: Event) {
    event.preventDefault();

    this.dataService.downloadFile(this.file.fileId)
      .subscribe((result) => {
        if (result.type === HttpEventType.DownloadProgress) {
        } else if (result.type === HttpEventType.Response) {
          FileSaver.saveAs(result.body as Blob, this.file.fileName);
        }
      },
        error => {
          this.notificationService.error(`Failed to download ${this.file.fileName} file.`);
        });
  }
}
